import React from 'react';

import { Skeleton, Tooltip } from '@mui/material';
import { useControlUnitById } from '../../../../../redux/controlUnit/hooks/useControlUnitById';
import useWatchError from '../../../../../handlingErrors/useWatchError';
import { useAppSelector } from '../../../../../redux/store.model';
import { getControlUnitByIdGetterSelector } from '../../../../../redux/controlUnit/selectors/table';

interface ControlUnitTextProps {
  controlUnitId?: number;
  deviceId?: string;
  commanderName?: string;
}
function ControlUnitText(props: ControlUnitTextProps) {
  const { controlUnitId, deviceId = '', commanderName } = props;
  const {
    data: controlUnit,
    isLoading: isLoadingControlUnit,
    error: errorControlUnits,
  } = useControlUnitById(deviceId, controlUnitId + '');

  const getControlUnit = useAppSelector(getControlUnitByIdGetterSelector);
  const cu = getControlUnit({
    deviceId: deviceId,
    controlUnitId: controlUnitId + '',
  });

  useWatchError(errorControlUnits);

  const name = controlUnit?.name ?? cu?.name ?? cu?.id?.toString() ?? '';
  const selectedName = controlUnitId === 1002 ? commanderName ?? name : name;
  const formatedName =
    selectedName?.charAt(0).toUpperCase() + selectedName?.slice(1);

  return (
    <>
      {isLoadingControlUnit ? (
        <Skeleton variant="rectangular" height={'1em'} width={'4em'} />
      ) : (
        <Tooltip title={formatedName}>
          <div style={{ width: 'fit-content' }}>{formatedName}</div>
        </Tooltip>
      )}
    </>
  );
}

export default ControlUnitText;
